import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { AdminSidebar } from "@/components/AdminSidebar";
import { Outlet, useLocation } from "react-router-dom";
import { AutoSaveProvider, useAutoSaveContext } from "@/hooks/useAutoSaveContext";
import { NavigationGuardProvider } from "@/hooks/useNavigationGuard";
import { Switch } from "@/components/ui/switch";

const EDITOR_PATTERNS = [/^\/paths\//, /^\/activities\//];

function HeaderBar() {
  const { autoSaveEnabled, toggleAutoSave } = useAutoSaveContext();
  const { pathname } = useLocation();
  const isEditor = EDITOR_PATTERNS.some((p) => p.test(pathname));

  return (
    <header className="sticky top-0 z-10 flex h-14 items-center justify-between border-b bg-background/80 px-4 backdrop-blur-sm">
      <SidebarTrigger />
      {isEditor && (
        <label className="flex items-center gap-2 text-sm text-muted-foreground cursor-pointer select-none">
          <Switch checked={autoSaveEnabled} onCheckedChange={toggleAutoSave} />
          Sauvegarde auto
        </label>
      )}
    </header>
  );
}

export default function AdminLayout() {
  return (
    <AutoSaveProvider>
      <NavigationGuardProvider>
        <SidebarProvider>
          <div className="flex min-h-screen w-full">
            <AdminSidebar />
            <main className="flex-1 overflow-auto">
              <HeaderBar />
              <div className="p-6">
                <Outlet />
              </div>
            </main>
          </div>
        </SidebarProvider>
      </NavigationGuardProvider>
    </AutoSaveProvider>
  );
}
